import type { Db } from './idb';

let handle: Db | null = null;

export function setDb(db: Db): void {
  handle = db;
}

export function getDb(): Db {
  if (!handle) throw new Error('database used before it was opened');
  return handle;
}
